import React from "react";
import Button from '@mui/material/Button';
import AccountCircle from '@mui/icons-material/AccountCircle';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import StayPrimaryPortraitIcon from '@mui/icons-material/StayPrimaryPortrait';
import { useLocation, useNavigate } from 'react-router-dom';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import "./branch.scss";
const BranchInformation = (props) => {
    const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))
    const intitalState = {
        branchName: "",
        branchCode: "",
        contactPerson: "",
        branchAddress: "",
        emailID: "",
        contactNumber: "",
        activeStatus: true,
        CreatedBy: getUserValue?.uniqueID

    }
    let location = useLocation();
    const navigate = useNavigate();
    const { submitBranchInfo } = props
    const [branchInfoInputFields, setbranchInfoInputFields] = React.useState(intitalState);

    const handleBranchInfoInputChange = (event) => {
        const { name, value } = event.target;
        setbranchInfoInputFields((prevState) => {
            return {
                ...prevState,
                [name]: value,
            };
        });
    }
    const handleGoBack = () => {
        navigate("/master/branch", { state: { addPatient: false, rowData: {} } })
    }
    return (
        <>
            
            <form>
                <div className="basic-info" >
                    <div className="mt-2 ml-4">
                        <h4>Branch Information</h4>
                        <div className="back-btn" onClick={handleGoBack}>
                            <ArrowBackIcon className="arrow-color" />
                            <span
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Branch Name*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AccountBalanceIcon /></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Branch Name" name="branchName" 
                                        value={branchInfoInputFields?.branchName} 
                                        onChange={handleBranchInfoInputChange} required />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Branch Code*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <input
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="text" className="form-control" 
                                        placeholder="Branch Code" name='branchCode' 
                                        value={branchInfoInputFields?.branchCode} 
                                        onChange={handleBranchInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Contact Person*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AccountCircle /></div>
                                    </div>
                                    <input
                                        type="text" 
                                        className="form-control" id="lname" 
                                        placeholder="Contact Person" name="contactPerson" 
                                        value={branchInfoInputFields?.contactPerson} 
                                        onChange={handleBranchInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Branch Address*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fa fa-address-card" aria-hidden="true"></i></div>
                                    </div>
                                    <input
                                        type="text" 
                                        className="form-control" id="lname" 
                                        placeholder="Branch Address" name="branchAddress" 
                                        value={branchInfoInputFields?.branchAddress} 
                                        onChange={handleBranchInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Mobile Number*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><StayPrimaryPortraitIcon /></div>
                                    </div>
                                    <input
                                        type="text" 
                                        className="form-control" 
                                        id="lname" 
                                        placeholder="Mobile Number" 
                                        name="mobileNumber" 
                                        value={branchInfoInputFields?.mobileNumber} 
                                        onChange={handleBranchInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Contact Number</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><StayPrimaryPortraitIcon /></div>
                                    </div>
                                    <input
                                        type="text" className="form-control" id="lname" 
                                        placeholder="Contact Number" name="contactNumber" 
                                        value={branchInfoInputFields?.contactNumber} onChange={handleBranchInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Email</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AlternateEmailIcon /></div>
                                    </div>
                                    <input
                                        type="email" 
                                        className="form-control" 
                                        id="fname" 
                                        placeholder="Email" 
                                        name="emailID" 
                                        value={branchInfoInputFields?.emailID} onChange={handleBranchInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2" onClick={(event) =>{
                        submitBranchInfo(event, branchInfoInputFields)
                        setbranchInfoInputFields(intitalState)
                    }}>Add Branch</Button>
                </div>
            </form>
        </>
    );
};

export default BranchInformation; 